import { navigate } from 'gatsby'
import { BLOCK_MARGIN_TOP, DISPLAY_WIDTH } from './constants'

export const isEmpty = obj => Object.keys(obj).length === 0

// MediaLibrarySectionTitle padding-top (MediaLibrary.styles.js) vs Advance
// Filter Articles (38px at all widths). Page 2+ should eat the laptopG bump
// so heading text sits closer to the sticky nav; do not restyle page 1.
export const MEDIA_LIBRARY_SECTION_TITLE_PADDING_TOP_PX = {
  default: 38,
  laptopG: 75
}

export const MEDIA_LIBRARY_PAGINATION_SCROLL_PAST_LAPTOP_G_PX =
  MEDIA_LIBRARY_SECTION_TITLE_PADDING_TOP_PX.laptopG -
  MEDIA_LIBRARY_SECTION_TITLE_PADDING_TOP_PX.default

const getStickySiteNavOffset = () => {
  if (typeof document === 'undefined') {
    return 0
  }
  const value = getComputedStyle(document.documentElement).getPropertyValue(
    '--sticky-site-nav-offset'
  )
  return parseFloat(value) || 0
}

const resolveExtraOffset = extraOffset => {
  const value =
    typeof extraOffset === 'function' ? extraOffset() : extraOffset
  return typeof value === 'number' && !Number.isNaN(value) ? value : 0
}

export const getMediaLibraryPaginationExtraOffset = () => {
  if (typeof window === 'undefined') {
    return 0
  }
  if (window.innerWidth < DISPLAY_WIDTH.laptopG) {
    return 0
  }
  // extraOffset is subtracted; negative scrolls further down.
  return -MEDIA_LIBRARY_PAGINATION_SCROLL_PAST_LAPTOP_G_PX
}

export const scrollWindowToTop = () => {
  if (typeof window === 'undefined') {
    return
  }
  window.scrollTo({ top: 0, behavior: 'auto' })
}

export const scrollWindowToElementId = (elementId, extraOffset = 0) => {
  if (typeof window === 'undefined') {
    return
  }
  const element = document.getElementById(elementId)
  if (!element) {
    return
  }
  const top =
    window.pageYOffset +
    element.getBoundingClientRect().top -
    getStickySiteNavOffset() -
    resolveExtraOffset(extraOffset)
  window.scrollTo({
    top: Math.max(top, 0),
    behavior: 'auto',
  })
}

export const paginationChange = page => {
  scrollWindowToTop()
  navigate(`?page=${page}`)
}

export const PAGINATION_FILTER_ANCHOR_ID = {
  ADVANCE: 'AdvanceFilterSectionAnchor',
  MEDIA_LIBRARY: 'MediaLibraryFilterSectionAnchor',
  CME_LIBRARY: 'CmeLibraryFilterSectionAnchor',
  RESOURCE_LIBRARY: 'ResourceLibraryFilterSectionAnchor',
  PRODUCT_DIRECTORY: 'ProductDirectoryFilterSectionAnchor',
  HCPD: 'HcpdFilterSectionAnchor',
}

export const paginationChangeToAnchor = (
  page,
  anchorId,
  extraOffset = 0
) => {
  navigate(`?page=${page}`)
  if (typeof window === 'undefined') {
    return
  }
  window.requestAnimationFrame(() => {
    scrollWindowToElementId(anchorId, extraOffset)
  })
}

export const createPaginationChangeToAnchor = (
  anchorId,
  extraOffset = 0
) => page => paginationChangeToAnchor(page, anchorId, extraOffset)

export const sliceBottomPadding = padding => {
  if (padding === undefined || padding === null || padding === '100%') {
    return `${BLOCK_MARGIN_TOP}px`
  }
  const paddingMultiplier = Number(padding.replace('%', '')) / 100
  return `${BLOCK_MARGIN_TOP * paddingMultiplier}px !important`
}
